export default __webpack_public_path__ + "static/media/fb.32f95b48.svg";